import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import moment from 'moment'
import { PortalsActionCreators } from 'app/reducers/PortalsRedux'
import { AuthActionCreators } from 'app/reducers/AuthRedux'
import Charts from './Charts'
import QuickAccess from './QuickAccess'
import { monthToDateFromAndTo } from 'selectors/portals'
import store from 'services/store'
import { IonIcon } from 'controls'
import Container from 'components/Layout/Container'
import HomeBannerSlider from 'components/MultiSlider/HomeBannerSlider'

import style, { container } from './styles'

class Dashboard extends Component {
  UNSAFE_componentWillMount() {
    const params = monthToDateFromAndTo(new Date().getMonth())
    const { actions, teamRemainderWasShown } = this.props
    const interval = {
      startDate: moment(new Date())
        .startOf('hour')
        .valueOf(),
      endDate: moment(new Date())
        .endOf('day')
        .valueOf()
    }
    actions.getLeads()
    actions.getMessages()
    actions.eventsRequest(interval.startDate, interval.endDate)
    actions.getCallRecordsStats(params.to, params.from)

    if (!teamRemainderWasShown) {
      actions.setOpenTeamRemainder(true)
    }
  }

  componentWillUnmount() {
    const { actions } = this.props
    actions.setOpenTeamRemainder(false)
  }

  render() {
    const { leads, messages, calls } = this.props
    const { response: responsEvents } = this.props.eventsRequestData

    const filterEvents = responsEvents ?  responsEvents.filter(event => event.customEventData) : []
    return (
      <Container>
        <section className="dashboard-container">
          <HomeBannerSlider />
          <QuickAccess leads={leads} messages={messages} calls={calls} />
          {filterEvents.length > 0 && (
            <div className="events container">
              <header>No olvides</header>
              {filterEvents.map((event, i) => (
                <div key={i}>
                  <strong>
                    {event.customEventData.title}
                    <br />
                    <span>{event.customEventData.description}</span>
                  </strong>
                  <span>
                    <IonIcon icon="ios-alert" />
                  </span>
                </div>
              ))}
            </div>
          )}
          <Charts />
        </section>
        <style jsx>{container}</style>
        <style jsx>{style}</style>
      </Container>
    )
  }
}

function mapStateToProps(state) {
  return {
    teamRemainderWasShown: Boolean(state.auth?.teamAssistant?.teamRemainderWasShown),
    leads: store.filter('property').selector(state),
    messages: store.filter('crmLeads').selector(state),
    calls: state.portals.tableCall.dataTableCalls,
    eventsRequestData: store.between('appointment').selector(state)
  }
}
const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        getLeads: store.filter('property').action,
        getMessages: store.filter('crmLeads').action,
        getCallRecordsStats: PortalsActionCreators.getDataTableCalls,
        eventsRequest: store.between('appointment').action,
        setOpenTeamRemainder: AuthActionCreators.setOpenTeamRemainder
      },
      dispatch
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Dashboard)
